// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"filter-sort"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M19.5 4H4.5L10.5 12.5V20H13.5V12.5L19.5 4Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.5 4H4.5L10.5 12.5V20H13.5V12.5L19.5 4Z","fillRule":"evenodd","strokeLinecap":"square","strokeWidth":"props.strokeWidth","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21.62 18.7651L20.0001 20.3896L18.3799 18.7651M21.62 15.222L20.0001 13.5996L18.3799 15.222","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FilterSortIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'filter-sort',
    ref,
    icon: element,
  },
));

FilterSortIcon.displayName = 'FilterSortIcon';

export default FilterSortIcon;
